import React, { useState } from 'react';
import logo from './logo.svg';
import './App.scss';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme } from './Helpers/MuiTheme';

import { RouterProvider } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthUser } from './Redux/Slices/AuthSlice';
import { createAppRouter } from './Helpers/AppRoutes';
import SnackbarComponent from './Components/SnackbarComponent';
import { ConfirmationProvider } from './Components/ConfirmationDialog';
import ErrorBoundary from './Components/ErrorBoundary';
import OfflineBanner from './Components/OfflineBanner';
import { LicenseInfo } from '@mui/x-date-pickers-pro';
LicenseInfo.setLicenseKey('e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y');


function App() {
  const dispatch = useDispatch();
  const [isDarkMode, setIsDarkMode] = useState(false);

  if (localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/auth`)) {
    const storedUser = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/auth`) || '{}');
    dispatch(setAuthUser(storedUser));
  }

  const toggleTheme = () => {
    setIsDarkMode((prevMode: any) => !prevMode);
  };

  const isAuthenticated = useSelector((state: any) => state.AuthSlice.isAuthenticated);
  const router = createAppRouter(isAuthenticated);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
        <CssBaseline />
        <ConfirmationProvider>
          <OfflineBanner />
          <SnackbarComponent />
          <RouterProvider router={router} />
        </ConfirmationProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
